import { forwardRef, Ref, type SVGProps } from 'react';

const SvgImpactPlaceholderIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 43"
    ref={ref}
    {...props}
  >
    <path
      fill="#C7F50A"
      fillRule="evenodd"
      d="M20 6a15.5 15.5 0 0 1 0 31 15.5 15.5 0 0 1 0-31m0 6.5a9 9 0 0 1 0 18 9 9 0 0 1 0-18m0 4.5a4.5 4.5 0 0 1 0 9 4.5 4.5 0 0 1 0-9"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgImpactPlaceholderIcon);
export default ForwardRef;
